import * as yup from 'yup'
import { DateSchema } from 'yup'
import { RECURRING_TYPE } from '../../civic-champs-shared/core/utils/constants/RECURRING_TYPE_OPTIONS'
import moment, { MomentInput } from 'moment'
import { SIMPLE_RECURRING_TYPE } from '../../civic-champs-shared/core/utils/constants/SIMPLE_RECURRING_TYPE_OPTIONS'
import { last } from 'lodash'

export const testEndIsAfterStart = (
  startDate: MomentInput,
  startTime: MomentInput,
  endDate: MomentInput,
  endTime: MomentInput,
) => {
  if (!startTime || !endTime) return true

  const start = moment(startTime)
  if (startDate) {
    const startMoment = moment(startDate)
    start.year(startMoment.year()).dayOfYear(startMoment.dayOfYear())
  }

  const end = moment(endTime)
  if (endDate) {
    const endMoment = moment(endDate)
    end.year(endMoment.year()).dayOfYear(endMoment.dayOfYear())
  }

  return end.isSameOrAfter(start)
}

export const eventDatePayloadSchema = yup.object({
  startDate: yup
    .date()
    .required('A start date is required. Please enter a start date.')
    .typeError('A start date is required. Please enter a start date.'),
  startTime: yup
    .date()
    .required('A start time is required. Please enter a start time.')
    .typeError('A start time is required. Please enter a start time.'),
  endDate: yup
    .date()
    .typeError('A end date is required. Please enter a end date.')
    .when(
      ['recurringType', 'isSchedulable'],
      (recurringType: RECURRING_TYPE, isSchedulable: boolean, schema: DateSchema) => {
        if (!isSchedulable || recurringType === RECURRING_TYPE.NEVER) return schema.nullable().notRequired()
        return schema
          .test('min-by-date', 'The end date cannot occur before the start date.', function (value: any) {
            return value && moment(value).isSameOrAfter(moment(this.parent.startDate), 'day')
          })
          .required('A end date is required. Please enter a end date.')
      },
    ),
  endTime: yup
    .date()
    .test('min-by-time', 'The end time cannot occur before the start time.', function (value: any) {
      return testEndIsAfterStart(this.parent.startDate, this.parent.startTime, this.parent.endDate, value)
    })
    .required('A end time is required. Please enter a end time.')
    .typeError('A end time is required. Please enter a end time.'),
  roles: yup
    .array()
    .of(
      yup.object({
        roleId: yup.number().typeError('Please select a Role').required('Please select a Role'),
        quantity: yup
          .number()
          .typeError('Registration limit is required')
          // @ts-ignore
          .id('Registration limit is required')
          .required('Registration limit is required'),
      }),
    )
    .notRequired(),
})

export const simpleEventDatePayloadSchema = yup.object({
  startTime: yup
    .date()
    .required('A start time is required. Please enter a start time.')
    .typeError('A start time is required. Please enter a start time.'),
  endDate: yup
    .date()
    .typeError('A end date is required. Please enter a end date.')
    .when(
      ['simpleRecurringType', 'isSchedulable'],
      (simpleRecurringType: SIMPLE_RECURRING_TYPE, isSchedulable: boolean, schema: DateSchema) => {
        if (!isSchedulable || simpleRecurringType === SIMPLE_RECURRING_TYPE.SELECTED_DATES)
          return schema.nullable().notRequired()
        return schema
          .test('min-by-date', 'The end date cannot occur before the start date.', function (value: any) {
            const lastDate = last(this.parent.dates) || this.parent.startDate

            if (!value || !lastDate) return true

            return moment(value).isSameOrAfter(moment(lastDate), 'day')
          })
          .required('A end date is required. Please enter a end date.')
      },
    ),
  endTime: yup
    .date()
    .test('min-by-time', 'The end time cannot occur before the start time.', function (value: any) {
      return testEndIsAfterStart(this.parent.startDate, this.parent.startTime, this.parent.endDate, value)
    })
    .required('A end time is required. Please enter a end time.')
    .typeError('A end time is required. Please enter a end time.'),
  roles: yup
    .array()
    .of(
      yup.object({
        roleId: yup.number().typeError('Please select a Role').required('Please select a Role'),
        quantity: yup
          .number()
          .typeError('Registration limit is required')
          // @ts-ignore
          .id('Registration limit is required')
          .required('Registration limit is required'),
      }),
    )
    .notRequired(),
  dates: yup
    .array()
    .of(yup.date())
    .when(['isSchedulable'], (isSchedulable: boolean, schema: DateSchema) => {
      if (!isSchedulable) {
        return schema.nullable().notRequired()
      } else {
        return schema
          .required('An event date is required. Please enter an event date.')
          .typeError('An event date is required. Please enter an event date.')
      }
    }),
})

export const editEventRolesPayloadSchema = yup.object({
  startTime: yup
    .date()
    .required('A start time is required. Please enter a start time.')
    .typeError('A start time is required. Please enter a start time.'),
  endTime: yup
    .date()
    .test('min-by-time', 'The end time cannot occur before the start time.', function (value: any) {
      //return testEndIsAfterStart(this.parent.startDate, this.parent.startTime, this.parent.endDate, value)
      return testEndIsAfterStart(this.parent.startDate, this.parent.startTime, this.parent.startDate, value)
    })
    .required('A end time is required. Please enter a end time.')
    .typeError('A end time is required. Please enter a end time.'),
  roles: yup
    .array()
    .of(
      yup.object({
        roleId: yup.number().typeError('Please select a Role').required('Please select a Role'),
        quantity: yup
          .number()
          .typeError('Registration limit is required')
          // @ts-ignore
          .id('Registration limit is required')
          .required('Registration limit is required'),
      }),
    )
    .notRequired(),
})
